<template>
  <vb-checkbox
    @change="handle_change"
    :vb_options="{
      text: 'Mostra in base al credito',
      value: filter_availability,
      checked: filter_availability,
      type: 'light',
      switch: true,
    }"
  />
</template>

<script>
export default {
  name: "search-by-credit",
  computed: {
    filter_availability: {
      get() {
        return this.$store.state.liveflight.filter_availability || false;
      },
      set(value) {
        this.$store.commit("liveflight/filter_availability", value);
      },
    },
  },
  methods: {
    handle_change(selected) {
      this.filter_availability = selected;
      this.scroll_top();
    },
  },
};
</script>
